import { call, put, takeEvery } from "redux-saga/effects"
import { CONCEPT_LOAD, CONCEPT_SAVE, CONCEPT_DELETE } from "./actionTypes"
import { conceptError, loadConcepts, saveConceptSuccess, deleteConcept } from "./actions"
import service from "../../../api/concept.service"

function* getConcepts(state) {
  try {
    const response = yield call(service.getConcepts, state.payload)
    yield put(loadConcepts(response.data))
  } catch (error) {
    yield put(conceptError(error.message))
  }
}

function* saveConcept({ payload: { concept } }) {
  try {
    const response =
      !concept.id
        ? yield call(service.save, concept)
        : yield call(service.update, concept)
    //errores de la llamada al servicio    
    const error = response?.response?.data?.error
    if (error) {
      yield put(conceptError(error))
    } else {
      yield put(saveConceptSuccess(response?.data))
    }

  } catch (error) {
    yield put(conceptError(error))
  }
}
function* deleteConcepts(ls) {
  try {
    const data = ls.payload;
    const response =
      yield call(service.deleteConcept,
        data.rows, data.createdBy)
    const error = response?.response?.data?.error

    if (error)
      yield put(conceptError(error))
    else {
      yield put(deleteConcept(response?.data))
    }

  } catch (error) {
    yield put(conceptError(error))
  }
}


function* conceptSaga() {
  yield takeEvery(CONCEPT_LOAD, getConcepts)
  yield takeEvery(CONCEPT_SAVE, saveConcept)
  yield takeEvery(CONCEPT_DELETE, deleteConcepts)
}

export default conceptSaga
